import { ETH_ADDRESS } from './chunk-THEIM6DM.mjs';
import { createDrift } from '@delvtech/drift';

var ReadEth = class {
  constructor(drift = createDrift()) {
    this.drift = drift;
  }
  async getName() {
    return "Ether";
  }
  async getSymbol() {
    return "ETH";
  }
  async getDecimals() {
    return 18;
  }
  async getAllowance() {
    return 2n ** 256n - 1n;
  }
  async getBalanceOf(account) {
    return this.drift.getBalance({ address: account });
  }
};
ReadEth.address = ETH_ADDRESS;

export { ReadEth };
//# sourceMappingURL=chunk-WO5AD7J3.mjs.map
//# sourceMappingURL=chunk-WO5AD7J3.mjs.map